import { Stack, Typography } from "@mui/material";
import type { FilterWidgetSettings } from "../../../../../../api/types/dashboardsTypes";
import type { DashboardFilter } from "../../../dashboard.types";
import FilterDropdown from "../FilterDropdown";
import DateDropdown from "./DateDropdown";

interface Props {
  filter: DashboardFilter | null;
  settings: FilterWidgetSettings;
  onSettingsChange: (settings: Partial<FilterWidgetSettings>) => void;
}

const DefaultValue = ({ filter, settings, onSettingsChange }: Props) => {
  if (!filter) {
    return null;
  }

  const isDate = filter.dataType === "date";

  return (
    <Stack sx={{ width: "100%", gap: 1 }}>
      <Typography variant="subtitle2">Default Value</Typography>
      {isDate && <DateDropdown settings={settings} onSettingsChange={onSettingsChange} />}
      {!isDate && (
        <FilterDropdown filter={filter} settings={settings} allowShowOnlySelected onSettingsChange={onSettingsChange} />
      )}
    </Stack>
  );
};

export default DefaultValue;
